let _ = require('lodash');
let moment = require('moment');



export let colHrsaScopeType = {colId: 'hrsaScopeType',headerName: 'HRSA Scope Type', field: 'hrsaScopeType',width: 100, sortable: true};

export let colGrantRestrictionType =    {
                                            colId: 'grantRestrictionsType',
                                            headerName: 'Grant Restriction Type',
                                            field: 'grantRestrictionsType',
                                            width: 100,
                                            sortable: true
                                        };

export let colGrantProgramNumber = {
                                        colId: 'grantProgramNumber',
                                        headerName: 'Grant Program Number',
                                        field: 'grantProgramNumber',
                                        width: 100,
                                        sortable: true
                                    };

export let colRevisedAwardValue =   {
                                        colId: 'revisedAwardValue',
                                        headerName: 'Revised Award Value', 
                                        field: 'revisedAwardValue',
                                        width: 100, 
                                        type: 'number',
                                        sortable: true,
                                        cellRenderer: currencyFormatter
                                    };

export let colGrantFundNumber = {
                                    colId: 'grantFundNumber',
                                    headerName: 'Grant Fund Number',
                                    field: 'grantFundNumber',
                                    width: 100,
                                    sortable: true
                                };

export let colGrantDocumentNumber = {
                                        colId: 'grantDocumentNumber',
                                        headerName: 'Grant Document Number',
                                        field: 'grantDocumentNumber',
                                        width: 100,
                                        sortable: true
                                    };

export let colGrantProgramKey = {
                                    colId: 'grantProgramKey',
                                    headerName: 'Grant Program Key',
                                    field: 'grantProgramKey',
                                    width: 100,
                                    sortable: true
                                };

export let colGrantUse = {colId: 'grantUse',headerName: 'Grant Use', field: 'grantUse', width: 100, sortable: true};




export let allColumns = [
    colHrsaScopeType,
    colGrantRestrictionType,
    colGrantProgramNumber,
    colRevisedAwardValue,
    colGrantFundNumber,
    colGrantDocumentNumber,
    colGrantProgramKey,
    colGrantUse
];



export let columnSelectList = [
    {
        value: colHrsaScopeType,
        viewValue: colHrsaScopeType.headerName
    },
    {
        value: colGrantProgramNumber,
        viewValue: colGrantProgramNumber.headerName
    },
    {
        value: colGrantRestrictionType,
        viewValue: colGrantRestrictionType.headerName
    },
    {
        value: colRevisedAwardValue,
        viewValue: colRevisedAwardValue.headerName
    },
    {
        value: colGrantFundNumber,
        viewValue: colGrantFundNumber.headerName
    },
    {
        value: colGrantDocumentNumber,
        viewValue: colGrantDocumentNumber.headerName
    },
    {
        value: colGrantProgramKey,
        viewValue: colGrantProgramKey.headerName
    },
    {
        value: colGrantUse,
        viewValue: colGrantUse.headerName
    }
];




function  dateFormatter(params) {

    if (params.value == undefined) {
        return 'none';
    } else {
        let dateObject = moment(params.value);
        let friendlyDate = dateObject.format('ll');

        if (friendlyDate == 'Invalid date') {
            // console.log('invalid date: ', params.value);
            return params.value;
        } else {
            // console.log('valid date: ', friendlyDate);
            return friendlyDate;
        }
    }
}

function dateExpired(param) {

    if (param.value != undefined) {
        let dateToEvaluate = moment(param.value);

        let daysPast = moment().diff(dateToEvaluate, 'days');
        // console.log('days past: ', daysPast);

        if (daysPast >= 0) {
        return {color: 'black', backgroundColor: 'red'};
        } else if (daysPast >= 180) {
        return {color: 'black', backgroundColor: 'yellow'};
        }
    }

}




function currencyFormatter(params) {

    let usdFormate = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
    });

    if (usdFormate.format(params.value) == '$0' ||
        (usdFormate.format(params.value) == '$NaN')) {
      return '$0.00';
    } else {
      return usdFormate.format(params.value);
    }

  }


function riskFormatter(param) {

    console.log('riskFormatter: ', param.data.riskScore);

    let scoreAsNumber = Number(param.data.riskScore);
    let scoreAsFloat = scoreAsNumber.toFixed(1);

    console.log('scoreAsFloat: ', scoreAsFloat);

    if ((scoreAsFloat != undefined) &&
        (scoreAsFloat != 'NaN')) {
      return scoreAsFloat;
    } else {
      return '';
    }
  }


  function missingCoiFormatter(param) {

    if (param.data.coiRequired) {
        return 'Yes';
    } else {
        return 'No';
    }
  }


  function missingBaaFormatter(param) {

    if (param.data.coiRequired) {
        return 'Yes';
    } else {
        return 'No';
    }
  }


  function missingSignatureFormatter(param) {

    if (param.data.coiRequired) {
        return 'Yes';
    } else {
        return 'No';
    }
  }


  function missingPoFormatter(param) {

    if (param.data.coiRequired) {
        return 'Yes';
    } else {
        return 'No';
    }
  }